// ── Two Truths One Lie — Player Controller ───────────────────────────────────

const ACCENT = "#B24BF3";

export default function TwoTruthsPlayer({
  phase, data, facts, setFacts, lieIndex, setLieIndex,
  voteData, voteProgress, result, voted, setVoted,
  onSubmit, onVote,
}) {
  const me = sessionStorage.getItem("playerName");

  // ── Result ────────────────────────────────────────────────────────────────
  if (phase === "result" && result) {
    const myVote = result.votes?.[me];
    const correct = myVote !== undefined && myVote === result.lie_index;
    const isSubject = result.subject === me;
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-3 animate-slide-up">
        <div style={{ fontSize:"var(--fs-3xl)" }}>
          {isSubject ? (result.subject_score > 0 ? "😈" : "😇") : (correct ? "🎯" : "😅")}
        </div>
        <div className="font-display text-center" style={{
          fontSize:"var(--fs-xl)",
          color: isSubject ? ACCENT : correct ? "#3dffa0" : "#ff8c00",
        }}>
          {isSubject
            ? (result.subject_score > 0 ? `Обманул ${result.subject_score / 75} чел!` : "Все разгадали!")
            : (correct ? "Ты угадал ложь!" : "Не угадал...")}
        </div>

        {/* Facts reveal */}
        <div style={{ display: "flex", flexDirection: "column", gap:"var(--gap-md)", width: "100%" }}>
          {(result.facts || []).map((fact, i) => {
            const isLie = i === result.lie_index;
            const myPick = myVote === i;
            return (
              <div key={i} style={{
                background: isLie ? "#ff335533" : "#00cc6622",
                border: `2px solid ${isLie ? "#ff3355" : "#00cc66"}`,
                borderRadius: "0.75rem", padding: "0.6rem 0.8rem",
                display: "flex", alignItems: "center", gap:"var(--gap-md)",
              }}>
                <div style={{ fontSize:"var(--fs-lg)", flexShrink: 0 }}>{isLie ? "❌" : "✅"}</div>
                <div style={{ flex: 1 }}>
                  <div className="font-heading text-white" style={{ fontSize:"var(--fs-sm)", lineHeight: 1.3 }}>
                    {fact}
                  </div>
                  {myPick && (
                    <div className="font-heading text-[#ffe600]" style={{ fontSize:"var(--fs-xs)", marginTop: "0.15rem" }}>
                      ← твой выбор
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // ── Subject waits for votes ───────────────────────────────────────────────
  if (phase === "subject_wait") {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-4 animate-slide-up">
        <div style={{ fontSize:"var(--fs-3xl)" }}>🤥</div>
        <div className="font-display text-center" style={{ fontSize:"var(--fs-xl)", color: ACCENT }}>
          Угадают ли твою ложь?
        </div>
        <div className="font-heading text-[#aaa] text-center" style={{ fontSize:"var(--fs-sm)" }}>
          Игроки голосуют...
        </div>
        {voteProgress && (
          <div className="font-heading text-[#555]" style={{ fontSize:"var(--fs-sm)" }}>
            {voteProgress.voted_count}/{voteProgress.total} проголосовали
          </div>
        )}
      </div>
    );
  }

  // ── Voting ────────────────────────────────────────────────────────────────
  if (phase === "voting" && voteData) {
    return (
      <div className="flex-1 flex flex-col gap-3 animate-slide-up">
        <div className="font-display text-center" style={{ fontSize:"var(--fs-xl)", color: ACCENT }}>
          🤔 Что ложь?
        </div>
        <div className="font-heading text-[#aaa] text-center" style={{ fontSize:"var(--fs-sm)" }}>
          {voteData.subject} написал(а) о себе:
        </div>
        {voted ? (
          <div className="flex-1 flex items-center justify-center">
            <div className="font-heading text-[#3dffa0] text-center" style={{ fontSize:"var(--fs-md)" }}>
              ✅ Голос принят!<br />
              <span style={{ color: "#555", fontSize:"var(--fs-sm)" }}>Ждём остальных...</span>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap:"var(--gap-md)" }}>
            {(voteData.facts || []).map((fact, i) => (
              <button key={i} onClick={() => { setVoted(true); onVote(i); }} style={{
                background: "#ffffff08", border: "2px solid #ffffff22",
                borderRadius: "0.75rem", padding: "0.8rem",
                color: "#fff", cursor: "pointer", width: "100%",
                textAlign: "left", lineHeight: 1.4,
                display: "flex", alignItems: "center", gap:"var(--gap-md)",
                WebkitTapHighlightColor: "transparent", touchAction: "manipulation",
              }}>
                <span style={{
                  background: ACCENT, borderRadius: "50%",
                  width: "1.6rem", height: "1.6rem",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#fff", flexShrink: 0,
                }}>
                  <span className="font-display" style={{ fontSize:"var(--fs-sm)" }}>{i + 1}</span>
                </span>
                <span className="font-heading" style={{ fontSize:"var(--fs-md)" }}>{fact}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── Input (subject writes facts) ──────────────────────────────────────────
  if (phase === "input") {
    const allFilled = facts.every(f => f.trim().length >= 2);
    return (
      <div className="flex-1 flex flex-col gap-3 animate-slide-up">
        <div className="font-display text-center" style={{ fontSize:"var(--fs-xl)", color: ACCENT }}>
          Твоя очередь!
        </div>
        <div style={{
          background: "#111", border: "1.5px solid #333",
          borderRadius: "0.75rem", padding: "0.6rem 0.8rem", textAlign: "center",
        }}>
          <div className="font-heading text-[#aaa]" style={{ fontSize:"var(--fs-xs)", marginBottom: "0.2rem" }}>ТЕМА</div>
          <div className="font-heading text-white" style={{ fontSize:"var(--fs-sm)", lineHeight: 1.3 }}>
            {data?.prompt}
          </div>
        </div>
        <div className="font-heading text-[#aaa] text-center" style={{ fontSize:"var(--fs-sm)" }}>
          Напиши 2 правды и 1 ложь. Отметь где ложь!
        </div>

        {facts.map((f, i) => (
          <div key={i} style={{ width: "100%", display: "flex", alignItems: "center", gap:"var(--gap-md)" }}>
            <button onClick={() => setLieIndex(i)} style={{
              width: "2rem", height: "2rem", flexShrink: 0, borderRadius: "50%",
              border: `2px solid ${lieIndex === i ? "#ff3355" : "#444"}`,
              background: lieIndex === i ? "#ff335533" : "transparent",
              cursor: "pointer", fontSize:"var(--fs-md)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: lieIndex === i ? "#ff3355" : "#666",
              WebkitTapHighlightColor: "transparent",
            }}>
              {lieIndex === i ? "❌" : "✓"}
            </button>
            <input
              value={f}
              onChange={e => { const n = [...facts]; n[i] = e.target.value; setFacts(n); }}
              placeholder={lieIndex === i ? `Факт ${i + 1} (ложь)` : `Факт ${i + 1} (правда)`}
              maxLength={200}
              style={{
                flex: 1, background: "#1a1a2e",
                border: `2px solid ${lieIndex === i ? "#ff3355" : "#333"}`,
                borderRadius: "0.6rem", padding: "0.6rem 0.8rem",
                color: "#fff", fontSize:"var(--fs-md)", outline: "none",
                fontFamily: "var(--font-body)",
              }}
            />
          </div>
        ))}

        <div className="font-heading text-[#555] text-center" style={{ fontSize:"var(--fs-xs)" }}>
          Нажми ❌ рядом с фактом чтобы пометить его как ложь
        </div>

        <button onClick={onSubmit} disabled={!allFilled} style={{
          background: allFilled ? ACCENT : "#333",
          border: "2.5px solid #000", borderRadius: "0.75rem",
          padding: "0.8rem", color: allFilled ? "#fff" : "#555",
          cursor: allFilled ? "pointer" : "not-allowed",
          boxShadow: allFilled ? "3px 3px 0 #000" : "none",
          width: "100%", transition: "all 0.15s",
          WebkitTapHighlightColor: "transparent",
        }}>
          <span className="font-heading" style={{ fontSize:"var(--fs-lg)" }}>🚀 Отправить!</span>
        </button>
      </div>
    );
  }

  // ── Waiting ───────────────────────────────────────────────────────────────
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4">
      <div style={{ fontSize:"var(--fs-3xl)" }}>⏳</div>
      <div className="font-display text-center" style={{ fontSize:"var(--fs-xl)", color: ACCENT }}>
        {data?.subject} пишет факты...
      </div>
      <div className="font-heading text-[#555] text-center" style={{ fontSize:"var(--fs-sm)" }}>
        Раунд {data?.round}/{data?.max_rounds}
      </div>
    </div>
  );
}
